import TableRowsLoader from './TableRowsLoader';

export default TableRowsLoader;
